import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, money } from "./bits";

export default function ProductCard({ p, i = 0 }) {
  const from = Math.min(...p.variants.map((v) => v.price));
  const watts = p.variants.map((v) => v.led_watts);
  const wattLabel = watts.length > 1 ? `${Math.min(...watts)}–${Math.max(...watts)}W` : `${watts[0]}W`;
  const allOut = p.variants.every((v) => v.stock === "sold_out");
  const someBack = !allOut && p.variants.some((v) => v.stock === "back_soon");
  return (
    <Reveal delay={i * 0.07}>
      <Link
        to={`/product/${p.slug}`}
        data-testid={`product-card-${p.slug}`}
        className="spotlight-card group block rounded-2xl border border-[#39FF14]/15 bg-[#0A150F] overflow-hidden"
        onMouseMove={(e) => {
          const r = e.currentTarget.getBoundingClientRect();
          e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
          e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
        }}
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-[#071009]">
          <div className="absolute inset-0 opacity-70" style={{ background: "radial-gradient(ellipse at 50% 100%, rgba(57,255,20,0.14), transparent 60%)" }} />
          <img
            src={p.image}
            alt={p.name}
            loading="lazy"
            className={`absolute inset-0 h-full w-full object-contain p-6 transition-all duration-700 ease-out group-hover:scale-[1.06] ${allOut ? "opacity-50 grayscale" : ""}`}
          />
          {allOut ? (
            <span data-testid={`sold-out-${p.slug}`} className="absolute left-4 top-4 rounded-full border border-red-400/40 bg-[#050B07]/85 px-3 py-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-red-300">
              Sold out
            </span>
          ) : (
            p.badge && (
              <span className="absolute left-4 top-4 rounded-full border border-[#39FF14]/30 bg-[#050B07]/80 px-3 py-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-[#39FF14]">
                {p.badge}
              </span>
            )
          )}
          {someBack && (
            <span data-testid={`back-soon-${p.slug}`} className="absolute left-4 top-12 rounded-full border border-amber-400/40 bg-[#050B07]/85 px-3 py-1 font-mono2 text-[10px] uppercase tracking-[0.2em] text-amber-300">
              Back soon
            </span>
          )}
          <span className="absolute right-4 top-4 rounded-full bg-[#0E1C13]/90 px-3 py-1 font-mono2 text-[10px] tracking-widest text-[#86EFAC]">
            {wattLabel}
          </span>
        </div>
        <div className="p-5">
          <div className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#4ADE80]">{p.series}</div>
          <h3 className="font-display mt-1 text-xl font-bold text-[#F0FDF4]">{p.name}</h3>
          <p className="mt-1 line-clamp-2 text-sm text-[#9FB8A8]">{p.tagline}</p>
          <div className="mt-4 flex items-center justify-between">
            <div className="font-display text-lg font-semibold text-[#F0FDF4]">
              <span className="mr-1 font-mono2 text-[10px] uppercase tracking-widest text-[#4ADE80]">from</span>
              {money(from)}
            </div>
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#39FF14]/25 text-[#39FF14] transition-all duration-300 group-hover:bg-[#39FF14] group-hover:text-[#050B07]">
              <ArrowUpRight className="h-4 w-4" />
            </span>
          </div>
        </div>
      </Link>
    </Reveal>
  );
}
